import { render, staticRenderFns } from "./Foot.vue?vue&type=template&id=52a54bc7&"
import script from "./Foot.vue?vue&type=script&lang=ts&"
export * from "./Foot.vue?vue&type=script&lang=ts&"
import style0 from "./Foot.vue?vue&type=style&index=0&id=52a54bc7&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports